import React from 'react';
import ReactDOM from 'react-dom/client';
import router from './App';
import reportWebVitals from './reportWebVitals';
import { RouterProvider } from 'react-router-dom';
import { GlobalSnackbars } from './components/utils/snack';
import './css/base.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
); 
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
    <GlobalSnackbars/>
  </React.StrictMode>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
